import AuthLogin from './Login'
import AuthPasswordSet from './PasswordSet'

export default function install(Vue) {
  Vue.component('auth-login', AuthLogin)
  Vue.component('auth-password-set', AuthPasswordSet)
}
